import http from "@/http-common";

export default class MA301060Service {

	getList (_params) {
		return http.get('/ma/ma301060', { params: _params}).then(res => res.data);
	}

	insertListAndupdateLsit(_data) {
		return http.post('/ma/ma301060/insertandupdate', _data).then(res => res.data);
	}

	insertList(_data) {
		return http.post('/ma/ma301060/insertlist', _data).then(res => res.data);
	}

	updateList( _data) {
		return http.patch('/ma/ma301060/updatelist', _data).then(res => res.data);
	}

	deleteList(_data) {
		return http.delete('/ma/ma301060', {data:JSON.stringify(_data)}).then(res => res.data);
	}

	insertOneFileList(_data, fileList) {
		let formData = new FormData();

		formData.append("sysNotice", new Blob([JSON.stringify(_data)], { type: "application/json" }));
		
		fileList.forEach(function(file) {
			formData.append("fileList", file);
		});

		return http.post('/ma/ma301060', formData, {headers: {'Conent-Type': 'multipart/form-data'}}).then(res => res.data);
	}

	updateOneFileList(_Id, _data, fileList) {
		let formData = new FormData();

		formData.append("sysNotice", new Blob([JSON.stringify(_data)], { type: "application/json" }));
		formData.append("fileList", fileList);

		return http.patch(`/ma/ma301060/${_Id}`.toString(), formData).then(res => res.data);
	}

}